import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { CancelToken } from "axios";

import ReportsListPage from "components/reportsList/ReportsListPage";
import { GetReport } from "api/rpc/2024-04/facilityAdmin/report/report";
import reportRoutes from "./ReportRoutes";
import { facilityReportCatalog } from "./reportCatalog";
import { getReportRouteCodes } from "pages/secure/shared/reports/reportRouteCodes";
import { useAppSelector } from "hooks/redux";

const facilityDedicatedRouteCodes = getReportRouteCodes(reportRoutes);

export default function Reports() {
  const { t } = useTranslation();
  const history = useHistory();
  const facilityStore = useAppSelector(store => store.facilityStore);
  const facilityShortName = facilityStore.facility?.short_name ?? "facility";

  const primaryAction = useMemo(
    () => ({
      content: t("Scheduled Reports"),
      action: () => history.push("/admin/report/scheduled"),
    }),
    [history, t],
  );

  const loadReports = useCallback(async (token?: CancelToken) => {
    const response = await GetReport({}, token ? false : true, token);
    return {
      status: response.status,
      data: response.data ?? [],
    };
  }, []);

  return (
    <ReportsListPage
      scope="facility"
      catalog={facilityReportCatalog}
      settingsKeyPrefix={facilityShortName}
      searchHistoryKey="facility-reports-search"
      loadReports={loadReports}
      errorMessage={t("secure.facility.reports.reports.002")}
      primaryAction={primaryAction}
      dedicatedRouteCodes={facilityDedicatedRouteCodes}
    />
  );
}
